export default {
  column: {
    display: 'inline-block',
    textAlign: 'left',
    verticalAlign: 'top',
    width: '100%',
  },
}
